import EntityType from '@enums/EntityType';
import { SkillEntity, TagEntity } from '@enums/MappedEntityTypes';

export default function buildSubTreeItems({ entity, orderItem }) {
  const { allowedIds, allowedSubIds, allowedValues, subType } = orderItem;

  switch (subType) {
    case EntityType.ACTIVITY_TYPE:
      if (allowedIds && !allowedIds.has(entity.library_uuid)) {
        return {
          subItems: [],
          type: EntityType.ACTIVITY_TYPE,
        };
      }
      return {
        subItems: [entity.library_uuid],
        type: EntityType.ACTIVITY_TYPE,
      };
    case EntityType.ROLE_TYPE:
      if (allowedSubIds && !allowedSubIds.has(entity.uuid)) {
        return {
          subItems: [],
          type: EntityType.ROLE_TYPE,
        };
      }
      return {
        subItems: [entity.title],
        type: EntityType.ROLE_TYPE,
      };
    case EntityType.SKILL:
      let skills = entity.skills;
      if (allowedValues) {
        skills = entity.skills.filter((skill) => {
          const hasSkill = allowedValues?.get(skill.uuid)?.has(skill.level);
          return hasSkill;
        });
      }
      return {
        subItems: skills,
        type: SkillEntity[entity.__type],
      };
    case EntityType.TAG:
      let tags = entity.tags?.length ? entity.tags : [EntityType.UNTAGGED];

      tags = allowedIds ? tags.filter((id) => allowedIds.has(id)) : tags;

      return {
        subItems: tags,
        type: TagEntity[entity.__type],
      };
    default:
      return [];
  }
}
